import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patient-mobile',
  templateUrl: './patient-mobile.component.html',
  styleUrls: ['./patient-mobile.component.scss']
})
export class PatientMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
